<template>
  <iframe
      v-if="chartUrl"
      :src="`https://${chartUrl}`"
      frameborder="0"
      allowtransparency
      :style="[
       { height: frameHeight } ,
       { width: frameWidth }
    ]"
  ></iframe>

  <div
      v-else-if="noMetabase"
      :style="[
       { height: frameHeight } ,
       { width: frameWidth }
    ]"
      class="text-center text-subtitle-2 py-4"
  >
    {{ lt('no_metabase') }}
  </div>

  <div
      v-else
      class="d-flex justify-center align-center "
      :style="[
       { height: frameHeight } ,
       { width: frameWidth }
    ]"
  >
    <v-progress-circular indeterminate color="primary"/>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted} from 'vue';
import {MetabaseProps, defaults} from './Metabase';
import {useLocalization} from "@/composables";
const { lt } = useLocalization('uiMetabase');

const props = withDefaults(defineProps<MetabaseProps>(), {
  chartParams: () => defaults.chartParams,
});
const chartUrl = ref<string | null>(null);
const noMetabase = ref(false);
const loading = ref(true);
import { useMetabaseApi } from '@ui-api3-sdk/api/api3';

async function getMetabaseUrl({resourceKey, resourceId, params}: {
  resourceKey: string;
  resourceId: number;
  params: Record<string, any>;
}) {
  const encodedKey = encodeURIComponent(resourceKey);
  const encodedId = encodeURIComponent(String(resourceId));
   await useMetabaseApi().getResourceUrl({resourceKey: encodedKey, resourceId: encodedId , getResourceUrlReq: params}  )
        .then(res => {
            chartUrl.value = res.data.payload.url
        })
        .catch( (e) => {
            throw new Error(`Failed to fetch Metabase URL: ${e}`);
        });

}

onMounted(async () => {
  try {
   await getMetabaseUrl({
      resourceKey: props.resourceKey,
      resourceId: props.resourceId,
      params: props.chartParams
    });
  } catch (err) {
    console.error(err);
    noMetabase.value = true;
  } finally {
    loading.value = false;
  }
});
</script>
